import type { TEventSchema, TPropertiesSchemaShape } from '../types/taxonomy.types';

export const defineTraitsSchema = <S extends TEventSchema>(traits: S & TPropertiesSchemaShape<S>) => traits;
